import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Stack,
  useTheme,
  Paper
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';

const Hero: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box 
      id="home"
      sx={{
        py: 8,
        background: theme.palette.mode === 'dark' 
          ? 'linear-gradient(45deg, #303030 30%, #212121 90%)' 
          : 'linear-gradient(45deg, #f5f5f5 30%, #e0e0e0 90%)',
      }}
    >
      <Container maxWidth="lg">
        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          spacing={4} 
          alignItems="center"
        >
          <Box sx={{ width: { xs: '100%', md: '50%' }, mb: { xs: 4, md: 0 } }}>
            <Typography 
              variant="h2" 
              component="h1" 
              gutterBottom
              sx={{ 
                fontWeight: 'bold',
                color: theme.palette.text.primary
              }}
            >
              Web Starter
            </Typography>
            <Typography 
              variant="h5" 
              color="textSecondary" 
              paragraph
              sx={{ mb: 4 }}
            >
              Package your static frontend files and backend startup files into an executable that runs through a browser.
            </Typography>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              href="/sign_in"
              startIcon={<PaymentIcon />}
              sx={{ 
                py: 1.5, 
                px: 3,
                boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)'
              }}
            >
              Pay and Start
            </Button>
          </Box>
          <Box sx={{ width: { xs: '100%', md: '50%' } }}>
            <Paper 
              elevation={6}
              sx={{ 
                p: 2, 
                borderRadius: 2,
                overflow: 'hidden',
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box
                component="img"
                src="/assets/web_starter_preview.png"
                alt="Web Starter Application"
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: 1,
                  display: 'block',
                }}
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                  // Fallback for missing image
                  e.currentTarget.src = 'data:image/svg+xml;charset=UTF-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%22500%22 height%3D%22300%22 viewBox%3D%220 0 500 300%22%3E%3Crect fill%3D%22%23f0f0f0%22 width%3D%22500%22 height%3D%22300%22%2F%3E%3Ctext fill%3D%22%23999%22 font-family%3D%22Arial%2CSans-serif%22 font-size%3D%2224%22 text-anchor%3D%22middle%22 x%3D%22250%22 y%3D%22150%22%3EWeb Starter Preview%3C%2Ftext%3E%3C%2Fsvg%3E';
                }}
              />
            </Paper>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Hero;
